import store from '@/store';
import { axios } from '@/services/apiClient';

export default {
  contactUs(jsonToSend) {
    return axios.post(store.state.apiUrl + 'contact-us/', jsonToSend);
  },
  getStaticData() {
    return axios.get(store.state.apiUrl + 'static-data/');
  },
};
